// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
    width: 100%;
}

.buy-throught-company-container {
    width: 100%;
    margin: 0;
}

.buy-throught-company-container .title {
    margin: 0 auto 10px;
}

.buy-throught-company-container form {
    background-color: #0e0f15;
    color: white;
    width: 100%;
    border: 2px solid #f09502;
    padding: 40px !important;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
}

.buy-throught-company-container form > div {
    width: 100%;
}

.buy-throught-company-container form label {
    margin-bottom: 3px;
    font-size: small;
}

.errorInput {
    background-color: rgb(255, 196, 196);
}

@media (max-width: 500px) {
    .buy-throught-company-container .title {
        margin: 15px auto 6px;
    }

    .buy-throught-company-container form {
        padding: 8px !important;
    }
}

.ml-10 {
    margin-left: 10px;
}

.form-check {
  padding: 10px 45px;
  border: 1px solid #b3b3b5;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/buy-through-company/buy-through-company/buy-through-company.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,SAAS;AACb;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,wBAAwB;IACxB,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI;QACI,qBAAqB;IACzB;;IAEA;QACI,uBAAuB;IAC3B;AACJ;;AAEA;IACI,iBAAiB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B","sourcesContent":[":host {\n    width: 100%;\n}\n\n.buy-throught-company-container {\n    width: 100%;\n    margin: 0;\n}\n\n.buy-throught-company-container .title {\n    margin: 0 auto 10px;\n}\n\n.buy-throught-company-container form {\n    background-color: #0e0f15;\n    color: white;\n    width: 100%;\n    border: 2px solid #f09502;\n    padding: 40px !important;\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    flex-wrap: wrap;\n}\n\n.buy-throught-company-container form > div {\n    width: 100%;\n}\n\n.buy-throught-company-container form label {\n    margin-bottom: 3px;\n    font-size: small;\n}\n\n.errorInput {\n    background-color: rgb(255, 196, 196);\n}\n\n@media (max-width: 500px) {\n    .buy-throught-company-container .title {\n        margin: 15px auto 6px;\n    }\n\n    .buy-throught-company-container form {\n        padding: 8px !important;\n    }\n}\n\n.ml-10 {\n    margin-left: 10px;\n}\n\n.form-check {\n  padding: 10px 45px;\n  border: 1px solid #b3b3b5;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
